import { render } from "./CreatePatient.vue?vue&type=template&id=7716e80c&scoped=true"
import script from "./CreatePatient.vue?vue&type=script&lang=js"
export * from "./CreatePatient.vue?vue&type=script&lang=js"

import "./CreatePatient.vue?vue&type=style&index=0&id=7716e80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7716e80c"]])

export default __exports__